import { toLower } from "lodash";
import React from "react";
import { Form } from "react-bootstrap";

import { FormControl } from "../..";

const FieldInputAlphaNumeric = ({ field, form, onChange, ...rest }) => {
  return (
    <FormControl {...field} {...form} {...rest}>
      <Form.Control
        onKeyPress={(e) => {
          var regex = new RegExp("^[a-zA-Z0-9 ]+$");
          var key = String.fromCharCode(!e.charCode ? e.which : e.charCode);
          if (!regex.test(key)) {
            e.preventDefault();
            return false;
          }
        }}
        {...field}
        {...form}
        {...rest}
      />
    </FormControl>
  );
};

export default FieldInputAlphaNumeric;
